import TestDetail from "./TestDetail";
import React, { useContext } from "react";
import constants from "../../../constants";
import WarningNotice from "./WarningNotice";
import AlertContext from "../../../context/AlertContext";
import InstructionPageWizard from "./InstructionPageWizard";

export default function InstructionPage() {
  const Alert = useContext(AlertContext);
  const isPreview = new URLSearchParams(window.location.search).get("mode") === "preview";  

  return (
    Alert.testData.libtype !== constants.libTypeIds.ASSIGNMENT && (
      <TestDetail />
    ),
    (
      <div className="instructionPageMainContainer">
        {Alert.status !== constants.PROGRESS_STATUS.UNLOCKED ||
          (Alert.status === constants.PROGRESS_STATUS.IN_PROGRESS &&
            Alert.testData.libtype === constants.libTypeIds.ASSIGNMENT && !isPreview && (
              <WarningNotice />
            ))}
        {Alert.status !== constants.PROGRESS_STATUS.IN_PROGRESS && (
          <InstructionPageWizard />
        )}
      </div>
    )
  );
}
